<template>
  <div class="see-doctor">
    <Banner></Banner>
    <service-flow></service-flow>
    <overseas-life></overseas-life>
    <blue-consultation></blue-consultation>
    <blue-footer></blue-footer>
  </div>
</template>

<script>
import Banner from "../components/blueCross/seeDoctor/banner/Index";
import ServiceFlow from "../components/blueCross/seeDoctor/serviceFlow/Index";
import OverseasLife from "../components/blueCross/seeDoctor/overseasLife/Index";
import BlueConsultation from "../components/blueCross/home/blueConsultation/Index";
import BlueFooter from "../components/blueCross/home/blueFooter/Index";
export default {
  name: "SeeDoctor",
  components: {
    Banner,
    ServiceFlow,
    OverseasLife,
    BlueConsultation,
    BlueFooter
  }
};
</script>

<style lang="scss" scoped></style>
